const borderWidths = [0, 1, 2, 4, 8, 16]

export default borderWidths
